export default "__VITE_ASSET__59175e23__"